import { getIconByType } from '@amo/core/utils/functions';
import RecapGPTSection from './RecapGPTSection';
import RecapGPTRow from './RecapGPTRow';

const usageLabels = {
    '1': 'Promenade',
    '2': 'Promenade + Trajet travail',
    '3': 'Affaires',
};

const boolLabel = (val) => {
    if (val === undefined || val === null) return null;
    return String(val) === '1' || val === true || val === 'true' ? 'Oui' : 'Non';
};

const RecapGPTVehicule = ({ vehiculeData, vehiculeInfo, typeVehicule, onEdit }) => {
    const marque = vehiculeInfo?.brand?.name;
    const modele = vehiculeInfo?.modele;
    const cylindree = vehiculeInfo?.cylindree;

    return (
        <RecapGPTSection title="Mon véhicule" icon={getIconByType(typeVehicule)} onEdit={onEdit}>
            {marque && <p className={'text-dark fw-bold'}>{marque} {cylindree && `${cylindree} cm³`}</p>}
            {modele && <p>{modele}</p>}
            <RecapGPTRow label="Immatriculation" value={vehiculeData?.Immatriculation} />
            <RecapGPTRow label="Date de mise en circulation" value={vehiculeData?.DateMEC} />
            <RecapGPTRow label="Date d'achat" value={vehiculeData?.DateAchatVehicule} />
            <RecapGPTRow label="Usage" value={usageLabels[vehiculeData?.UsageVehicule] || vehiculeData?.UsageVehicule} />
            <RecapGPTRow label="Code postal garage" value={vehiculeData?.CodePostalGarage} />
            <RecapGPTRow label="Ville garage" value={vehiculeData?.VilleGarage} />
            <RecapGPTRow label="Titulaire carte grise" value={boolLabel(vehiculeData?.TitulaireCarteGrise)} />
            <RecapGPTRow label="Carte grise française" value={boolLabel(vehiculeData?.CarteGriseFrancaise)} />
            <RecapGPTRow label="Véhicule immatriculé" value={boolLabel(vehiculeData?.VehiculeImmatricule)} />
            <RecapGPTRow label="Possession > 3 mois" value={boolLabel(vehiculeData?.PossessionPlusDe3Mois)} />
            <RecapGPTRow label="Assuré 3 derniers mois" value={boolLabel(vehiculeData?.Assure3DerniersMois)} />
        </RecapGPTSection>
    );
};

export default RecapGPTVehicule;
